import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ConsultantService } from 'src/app/services/consultant.service';
import { ConsultantComponent } from './consultant/consultant.component';
import { Consultant, ConsultantSalary, POSITION_LABELS, Position } from 'src/app/models/consultant.model';
import { Department } from 'src/app/models/department.model';
import { DepartmentService } from 'src/app/services/department.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-consultants',
    templateUrl: './consultants.component.html',
    styleUrls: ['./consultants.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsultantsComponent implements OnInit {

  loading = true;
  displayedColumns: string[] = ['actions', 'name', 'initials', 'department', 'email', 'dashboardAccess', 'includedInDashboard', 'monthlySalary', 'monthlySharedExpenses', 'position', 'bonusPercentage'];
  @ViewChild(MatTable<Consultant>) table: MatTable<Consultant>;
  dataSource: MatTableDataSource<Consultant>;
  departments: Department[];
  POSITION_LABELS = POSITION_LABELS;
  Position = Position;

  constructor(
    private snackBar: MatSnackBar,
    protected dialog: MatDialog,
    protected consultants: ConsultantService,
    protected departmentsService: DepartmentService
  ) {

  }

  async ngOnInit(): Promise<void> {
    await this.loadConsultants();
  }

  async loadConsultants() {
    this.loading = true;
    this.departments = await this.departmentsService.list();
    let consultants = await this.consultants.list();
    // consultants.sort((a, b) => {
    //   if (a.name?.toLocaleLowerCase()?.charCodeAt(0) > b.name?.toLocaleLowerCase()?.charCodeAt(0)) return 1;
    //   else if (a.name?.toLocaleLowerCase()?.charCodeAt(0) < b.name?.toLocaleLowerCase()?.charCodeAt(0)) return -1;
    //   return 0;
    // });
    this.dataSource = new MatTableDataSource(consultants);
    this.loading = false;
  }

  department(id: string) {
    return this.departments.find(_ => _.id == id)?.name;
  }

  currentSalary(consultant: Consultant): ConsultantSalary | undefined {
    if (!consultant.salaries || consultant.salaries.length === 0) return undefined;
    const currentYear = new Date().getFullYear();
    return consultant.salaries
      .filter(s => s.year != null && s.year <= currentYear)
      .reduce<ConsultantSalary | undefined>(
        (best, s) => !best || (s.year ?? 0) > (best.year ?? 0) ? s : best,
        undefined
      );
  }

  createConsultant() {
    let dialogRef = this.dialog.open(ConsultantComponent, {
      width: '50%',
      data: { consultant: new Consultant() },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(async created => {
      if (created) {
        await this.loadConsultants();
      }
    });
  }

  openConsultant(consultant: Consultant) {
    let dialogRef = this.dialog.open(ConsultantComponent, {
      width: '50%',
      data: { consultant: structuredClone(consultant) },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(updated => {
      if (updated) {
        let idx = this.dataSource.data.findIndex(_ => _.id == updated.id);
        this.dataSource.data[idx] = updated;
        this.table.renderRows();
      }
    });
  }

  async deleteConsultant(consultant: Consultant) {
    if (await this.consultants.canDelete(consultant.id)) {
      if (window.confirm("Vil du slette " + consultant.initials)) {
        if (await this.consultants.delete(consultant.id)) {
          await this.loadConsultants();
        }
      }
    } else {
      this.snackBar.open(consultant.initials + " kan ikke slettes da denne indgår i en ordre eller faktura", "Luk", { panelClass: 'snackbar-error', duration: 0 });
    }
  }
}
